import { SkeletonBody } from '@xing-com/skeleton';

import { Styled } from './skeleton-relevant-links.styles';

export const SkeletonRelevantLinks: React.FC = () => (
  <Styled.GridItem span={12} spanMedium={6}>
    <Styled.SkeletonHeadline amountRows={1} />
    <SkeletonBody />
  </Styled.GridItem>
);
